import { isPlatformBrowser, NgIf, NgFor } from '@angular/common';
import { Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateHelper } from '@app/_helpers';
import { DirectionService } from '@app/_services/direction.service';
import { Link } from '@interfaces/link';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { SearchComponent } from '../search/search.component';
import { OwlPreventClickDirective } from '../../directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, RouterLink, IconComponent, CarouselModule, OwlPreventClickDirective, SearchComponent]
})
export class PageHeaderComponent implements OnInit, OnChanges {
    @Input() header: string;
    @Input() breadcrumbs: Link[] = [];
    @Input() showSearch = false;
    @Input() headerClass;
    @Input() subCategroies = null;
    carouselOptions = {
        //items: 5,
        touchDrag: true,
        mouseDrag: true,
        skip_validateItems: true,
        margin: 13,
        dots: false,
        autoWidth: true,
        rtl: this.direction.isRTL()
    };

    currentLang = this.translate.currentLang;
    selectedcategory;
    constructor(public translateHelper: TranslateHelper,
        public direction: DirectionService,
        private route: ActivatedRoute,
        @Inject(PLATFORM_ID) private platformId: any,
        private translate: TranslateService,) { }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.subCategroies) {
            this.calculateCategoryTextWidth();
        }
    }


    ngOnInit(): void {
        this.calculateCategoryTextWidth();
        this.route.data.subscribe(data => {
            const category = data?.categoryProducts?.category;
            let catId = category?.path && category?.path[1] ? category?.path[1] : category?._id;
            this.selectedcategory = _.find(this.subCategroies, ["_id", catId])?.seo?.slug;
        })
    }

    calculateCategoryTextWidth() {
        if (isPlatformBrowser(this.platformId)) {
            _.forEach(this.subCategroies, (category, key) => {
                let element = document.createElement('canvas');
                let context = element.getContext("2d");
                context.font = "15px Lato, sans-serif";
                let fontSize = context.measureText(category?.name?.[this.translate.currentLang]).width;
                this.subCategroies[key].width = fontSize + (this.direction.isRTL() ? 55 : 45);
            });
        }
    }
}
